export default __webpack_public_path__ + "assets/tune.852344d1.svg";